import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/demand/transfer-requests");

export const Route = createFileRoute("/demand/transfer-requests")({
  head: () => ({
    meta: [
      { title: "Transfer requests — LevelLoad" },
      { name: "description", content: "Transfer requests — LevelLoad transport planning." },
      { property: "og:title", content: "Transfer requests — LevelLoad" },
      { property: "og:description", content: "Transfer requests — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
